export default __webpack_public_path__ + "static/media/bar.34bbe2e7.svg";